/* tslint:disable */
/* eslint-disable */
/**
 * attachmentAV
 * An SDK to integrate virus and malware scan capabilities into JavaScript / TypeScript applications. Scan files for viruses, trojans, and other kinds of malware with attachmentAV powered by Sophos.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CallbackFailure
 */
export interface CallbackFailure {
    /**
     * 
     * @type {string}
     * @memberof CallbackFailure
     */
    id: string;
    /**
     * 
     * @type {Date}
     * @memberof CallbackFailure
     */
    time: Date;
    /**
     * 
     * @type {string}
     * @memberof CallbackFailure
     */
    downloadUrl: string;
    /**
     * 
     * @type {string}
     * @memberof CallbackFailure
     */
    callbackUrl: string;
    /**
     * 
     * @type {string}
     * @memberof CallbackFailure
     */
    errorJson: string;
}

/**
 * Check if a given object implements the CallbackFailure interface.
 */
export function instanceOfCallbackFailure(value: object): value is CallbackFailure {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('time' in value) || value['time'] === undefined) return false;
    if ((!('downloadUrl' in value) && !('download_url' in value)) || (value['downloadUrl'] === undefined && value['download_url'] === undefined)) return false;
    if ((!('callbackUrl' in value) && !('callback_url' in value)) || (value['callbackUrl'] === undefined && value['callback_url'] === undefined)) return false;
    if ((!('errorJson' in value) && !('error_json' in value)) || (value['errorJson'] === undefined && value['error_json'] === undefined)) return false;
    return true;
}

export function CallbackFailureFromJSON(json: any): CallbackFailure {
    return CallbackFailureFromJSONTyped(json, false);
}

export function CallbackFailureFromJSONTyped(json: any, ignoreDiscriminator: boolean): CallbackFailure {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'time': (new Date(json['time'])),
        'downloadUrl': json['download_url'],
        'callbackUrl': json['callback_url'],
        'errorJson': json['error_json'],
    };
}

export function CallbackFailureToJSON(json: any): CallbackFailure {
    return CallbackFailureToJSONTyped(json, false);
}

export function CallbackFailureToJSONTyped(value?: CallbackFailure | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'time': value['time'].toISOString(),
        'download_url': value['downloadUrl'],
        'callback_url': value['callbackUrl'],
        'error_json': value['errorJson'],
    };
}

